import type { ReactNode } from 'react';

export const symbol_format_size: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M570-700H410q-20.83 0-35.42-14.62Q360-729.24 360-750.12q0-20.88 14.58-35.38Q389.17-800 410-800h420q20.83 0 35.42 14.62Q880-770.76 880-749.88q0 20.88-14.58 35.38Q850.83-700 830-700H670v490q0 20.83-14.62 35.42Q640.76-160 619.88-160q-20.88 0-35.38-14.58Q570-189.17 570-210v-490ZM210-500h-80q-20.83 0-35.42-14.62Q80-529.24 80-550.12 80-571 94.58-585.5 109.17-600 130-600h260q20.83 0 35.42 14.62Q440-570.76 440-549.88q0 20.88-14.58 35.38Q410.83-500 390-500h-80v290q0 20.83-14.62 35.42Q280.76-160 259.88-160q-20.88 0-35.38-14.58Q210-189.17 210-210v-290Z"
		/>
	</svg>
);
